import React from 'react';
import qCategories from "@assets/gql/tvarumas.categories.gql";
import { useQuery } from '@apollo/client';
import client from '@gql/client';
import { LoadingBox } from '@assets/tsx/loadingBox/loadingBox';
import Card from '@widgets/card/card';
import { __ } from '@wordpress/i18n';
import { useLang } from '@ambiguous/useLang';
export default function TvarumasCategories({ lang }) {
    var _a;
    const [language] = useLang();
    const { data, loading } = useQuery(qCategories, { client, variables: {
            language: language.toUpperCase()
        } });
    return React.createElement("div", { className: "ltg-tvarumas-categories" }, loading ? React.createElement(React.Fragment, null,
        React.createElement(Loading, null)) : React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } }, (_a = data === null || data === void 0 ? void 0 : data.tvarumoKategorijos) === null || _a === void 0 ? void 0 : _a.nodes.map(({ id, name, uri, tvarumoKategorijaFields }) => {
            var _a;
            const { altText, databaseId: imageId, sourceUrl } = ((_a = tvarumoKategorijaFields === null || tvarumoKategorijaFields === void 0 ? void 0 : tvarumoKategorijaFields.thumbnail) === null || _a === void 0 ? void 0 : _a.node) || {};
            return React.createElement("div", { key: id },
                React.createElement(Card, { title: name, image: { id: imageId, url: sourceUrl, alt: altText }, url: uri, bg_color: undefined, buttons: [
                        { url: uri, title: __('Plačiau', 'ltg-widgets'), _id: 'btn-0', color: 'white', icon: null }
                    ], content: '', url__props: undefined, underscored: true, image_stretch: 'yes', image_stretch_vertical: undefined, image_square: undefined, switch_layout: undefined, logos: [], ulist: [] }));
        }))));
}
function Loading() {
    const boxArr = new Array(5).fill(null);
    return React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 16 } }, boxArr.map((_, i) => (React.createElement(LoadingBox, { key: i, style: { height: 224 } }))));
}
